import { ErrorDisplay } from '@automata/ui';
import { getErrorMessage } from '@automata/utils';
import { Box } from '@mui/material';

export type Props = {
  error: unknown;
};

export const Fallback = ({ error }: Props): JSX.Element => {
  return (
    <Box
      p={2}
      height="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <ErrorDisplay
        title="SDK Interoperability Error"
        error={error}
        logToConsole={false}
        userMessage={getErrorMessage(
          error,
          'An error occurred in Canvas. See console for details.'
        )}
      />
    </Box>
  );
};
